import React, { useEffect } from "react";
import { Box } from "@mui/system";
import Header from "../../../common/header/Header";
import ReportSettingsLayout from "./ReportSettingsLayout";
import Breadcrumb from "../../../common/header/Breadcrumb";
import "../../../../assets/styles/containers/_reportSettings.scss";

const ReportSettings = () => {
  document.title = "ISN - Report Settings";
  useEffect(() => {
              window.scrollTo(0, 0);
          }, []);
  return (
    <Box sx={{ flexGrow: 1 }} className="page-background">
      <Header />
      <div className="report-settings-page-content">
        <Breadcrumb />
        <ReportSettingsLayout />
      </div>
    </Box>
  );
};

export default ReportSettings;
